'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductGroup = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _verify = require('helpers/verify');

var _ContextVariables = require('providers/ContextVariables');

var _CallToAction = require('components/CallToAction');

var _ProductCard = require('./cards/ProductCard');

var _SignupCard = require('./cards/SignupCard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductGroup = exports.ProductGroup = function (_Component) {
  (0, _inherits3.default)(ProductGroup, _Component);

  function ProductGroup() {
    var _ref;

    (0, _classCallCheck3.default)(this, ProductGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProductGroup.__proto__ || (0, _getPrototypeOf2.default)(ProductGroup)).call.apply(_ref, [this].concat(args)));

    _this.CARD_RENDERER_BY_TYPE = {
      productcard: _this.renderProductCard.bind(_this),
      signupcard: _this.renderSignupCard.bind(_this)
    };
    return _this;
  }

  (0, _createClass3.default)(ProductGroup, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.msaId !== prevProps.msaId) {
        this.props.loadCardData({
          productType: this.props.productType,
          productCode: this.props.productCode
        });
      }
    }
  }, {
    key: 'selectCardRenderer',
    value: function selectCardRenderer(type) {
      var normalizedType = (type || '').toLowerCase();
      return this.CARD_RENDERER_BY_TYPE[normalizedType] || this.CARD_RENDERER_BY_TYPE.productcard;
    }
  }, {
    key: 'renderProductCard',
    value: function renderProductCard() {
      var _props = this.props,
          card = _props.card,
          cmsModuleId = _props.cmsModuleId;

      var _ref2 = card || {},
          ctaCopy = _ref2.ctaCopy,
          url = _ref2.url;

      var cta = ctaCopy && url && _react2.default.createElement(
        _CallToAction.CallToAction,
        {
          action: _CallToAction.ACTIONS.LINK,
          color: 'primary_solid',
          extraClass: 'bt--lg bt--width-full',
          to: url
        },
        ctaCopy
      );

      return _react2.default.createElement(_ProductCard.ProductCard, (0, _extends3.default)({}, card, { cta: cta, cmsModuleId: cmsModuleId }));
    }
  }, {
    key: 'renderSignupCard',
    value: function renderSignupCard() {
      var _props2 = this.props,
          card = _props2.card,
          cmsModuleId = _props2.cmsModuleId;


      return _react2.default.createElement(_SignupCard.SignupCard, (0, _extends3.default)({}, card, { cmsModuleId: cmsModuleId }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          card = _props3.card,
          cardType = _props3.cardType,
          disclaimer = _props3.disclaimer,
          msaId = _props3.msaId;


      if ((0, _verify.isEmpty)(card)) {
        return null;
      }

      var Card = this.selectCardRenderer(cardType);

      return _react2.default.createElement(
        'div',
        { className: 'ProductGroup' },
        _react2.default.createElement(
          'div',
          { className: 'ProductGroup__cards' },
          _react2.default.createElement(
            _ContextVariables.DefineVariables,
            { variables: card.contextVariables },
            _react2.default.createElement(Card, { key: msaId })
          )
        ),
        disclaimer && _react2.default.createElement(
          'p',
          { className: 'ProductGroup__disclaimer' },
          disclaimer
        )
      );
    }
  }]);
  return ProductGroup;
}(_react.Component);

ProductGroup.propTypes = {
  card: _propTypes2.default.object,
  cardType: _propTypes2.default.string,
  cmsModuleId: _propTypes2.default.string.isRequired,
  disclaimer: _propTypes2.default.node,
  loadCardData: _propTypes2.default.func.isRequired,
  hasEmbeddedSignup: _propTypes2.default.bool,
  msaId: _propTypes2.default.number,
  productCode: _propTypes2.default.string,
  productType: _propTypes2.default.string
};